export default "__VITE_ASSET__CXW4nHPk__"